import React from 'react'
import __ from '../../../../react/utils/i18n'

const SearchResult = ({ result, col }) => {
  let type
  switch (result.type) {
    case 'wwp3_sponsor':
      type = __('Sponsor')
      break

    case 'wwp3_offer':
      type = __('Angebot')
      break

	  case 'wwp3_job':
		  type = __('Stellenangebot')
		  break

	  case 'wwp3_event':
		  type = __('Veranstaltung')
		  break

	  case 'wwp3_news_entry':
		  type = __('News')
		  break
    default:
      break
  }
  return (
    <li
      className="wwp3-sponsor-list wwp3-column"
      style={{ flex: `0 1 ${col}` }}
    >
      <a className="wwp3-sponsor-list__inner" href={result.permalink}>
        <small>{type}</small>
        <div className="wwp3-sponsor-list__logo">
          <img
            src={result.image}
            className="attachment-full size-full"
            alt=""
          />
        </div>
        <div className="wwp3-sponsor-list__info">
          <span className="wwp3-sponsor-list__label">{result.title}</span>
          <br />
        </div>
      </a>
    </li>
  )
}

export default SearchResult



// WEBPACK FOOTER //
// src/assets/js/front-end/apps/search/components/SearchResult.js